import React from 'react'
import { __t } from '../../../../i18n/t'
import { DiscountKind, earnOn, showsEarn, showsLimit } from '../model'
import { useWiz } from '../state/WizardContext'
import { Callout } from '../ui/basics'
import { SwitchCard } from '../ui/controls'
import { FuelsSection } from './values/FuelsSection'
import { LimitSection } from './values/LimitSection'
import { OverlapSection } from './values/OverlapSection'
import { StationsSection } from './values/StationsSection'

/** Etapa 2: onde vale e quanto é o desconto. */
export const StepValues: React.FC = () => {
  const { d, c, set } = useWiz()
  const earn = earnOn(d, c)
  const chainOff = c.chain.pointsWhenDiscounting === false
  const reward = d.kind === DiscountKind.reward
  return (
    <>
      <StationsSection />
      <FuelsSection />
      <OverlapSection />
      {showsLimit(d.kind) ? <LimitSection /> : null}
      {showsEarn(d.kind) ? (
        <>
          <SwitchCard
            id="earn"
            checked={earn}
            onChange={() => set(x => ({ ...x, earnPoints: !earn }))}
            title={__t('Pontuar ao usar desconto')}
            desc={earn
              ? __t('O cliente também ganha pontos neste abastecimento.')
              : reward
                ? __t('Só o desconto, sem pontos.')
                : __t('Só o desconto. O app mostra “Não acumula pontos”.')}
          />
          {chainOff && earn ? (
            <Callout tone="info" sx={{ maxWidth: 640, fontSize: 13.5 }}>
              {__t('Na rede, “Pontuar quando usar desconto” está desligado: o cliente não ganha pontos mesmo com esta opção ligada.')}
            </Callout>
          ) : null}
        </>
      ) : null}
      {reward || d.kind === DiscountKind.recovery ? (
        <Callout tone="info" sx={{ maxWidth: 760 }}>
          {reward
            ? __t('Só aparece para quem conquistou o brinde. Vale uma vez, na validade do brinde.')
            : __t('Só aparece para quem recebeu o cupom da campanha. Vale uma vez.')}
        </Callout>
      ) : null}
    </>
  )
}
